import { useAnchorAccount, useAnchorAccounts, } from "@helium/helium-react-hooks";
import { proposalKey } from "@helium/organization-sdk";
import { useMemo } from "react";
export const useProposalConfig = (key) => useAnchorAccount(key, "proposalConfigV0");
export const useProposal = (key) => useAnchorAccount(key, "proposalV0");
export const useOrganization = (key) => useAnchorAccount(key, "organizationV0");
export const useResolutionSettings = (key) => useAnchorAccount(key, "resolutionSettingsV0");
export const useOrganizationProposals = (organizationKey) => {
    const { info: organization } = useOrganization(organizationKey);
    const proposalKeys = useMemo(() => Array(organization?.numProposals)
        .fill(0)
        .map((_, index) => proposalKey(organizationKey, index)[0])
        .reverse(), [organization?.numProposals]);
    return useAnchorAccounts(proposalKeys, "proposalV0");
};
//# sourceMappingURL=index.js.map